import http, { httpmock } from '@/utils/http';
import { replaceEquals } from '@/utils/mockups/escapeString';
const endpoint = 'facility-setting';

export default {
  async getLanguages (facility_id, no_loader) {
    const isCheckinRoute = true;
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = { facility_id, name: 'language', paginate: false, isCheckinRoute: isCheckinRoute }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getFaceRecognitionSettings (facility_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    config.params = { facility_id }
    const response = await http.get(`face-recognition-settings/${facility_id}`, config);
    return response.data;
  },
  async updateFaceRecognitionSettings (data, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const { facility_id } = data;
    config.params = { facility_id }
    const response = await http.put(`face-recognition-settings/${facility_id}`, data, config);
    return response.data;
  },
  async getMaintenanceSettings (facility_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const data = {
      facility_id,
      name: 'maintenance_mode',
      paginate: false
    }
    const response = await http.post(`facility-setting/list`, data, config);
    return response.data;
  },
  async getNotifications (facility_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = { facility_id, name: 'notification_frequency_settings', paginate: false }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getTerms (facility_id, lang, no_loader) {
    const isCheckinRoute = true;
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = { facility_id, name: `terms-conditions-${lang}`, paginate: false, isCheckinRoute: isCheckinRoute }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getForm (facility_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = { facility_id, name: 'form', paginate: false }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getConfirmLock (facility_id, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = { facility_id, name: 'confirm_lock', paginate: false }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getMyPageSetting (facility_id, settingKey, lang, isCheckinRoute = false, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const query = {
      facility_id,
      name: `mypage-${settingKey}-${lang}`,
      paginate: false,
      isCheckinRoute
    }
    const response = await http.post(`${endpoint}/list`, query, config);
    return response.data;
  },
  async getMyPageA (facility_id, lang, isCheckinRoute = false, no_loader) {
    return this.getMyPageSetting(facility_id, 'A', lang, isCheckinRoute, no_loader);
  },
  async getMyPageB (facility_id, lang, isCheckinRoute = false, no_loader) {
    return this.getMyPageSetting(facility_id, 'B', lang, isCheckinRoute, no_loader);
  },
  async getMyPageC (facility_id, lang, isCheckinRoute = false, no_loader) {
    return this.getMyPageSetting(facility_id, 'C', lang, isCheckinRoute, no_loader);
  },
  async save (data, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    let processedData;
    if (data.name && data.name.includes('terms-conditions')) {
        processedData = {
            ...data,
            value: {
                content: replaceEquals(data.value.content)
            }
        };
    } else {
        processedData = data;
    }
    const response = await http.post(`${endpoint}/store`, processedData, config);
    return response.data;
  },
  async updateFrequency (data, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const response = await http.post(`${endpoint}/update-frequency`, { ...data }, config);
    return response.data;
  },
  async updateSms (data, no_loader) {
    const config = no_loader ? { headers: { 'no-loader': true } } : {};
    const response = await http.post(`${endpoint}/update-sms-status`, { ...data }, config);
    return response.data;
  }
}
